/**
 * Firebase `sendPasswordResetEmail` + ActionCodeSettings requires the `url` hostname to be in
 * Authentication → Settings → Authorized domains. Custom domains (volocean.com, app.voluntas.com)
 * are often missing there; the project's Hosting *.web.app URL is normally authorized automatically.
 *
 * Override: REACT_APP_FIREBASE_HOSTING_CANONICAL_URL (e.g. https://voluntas.web.app)
 *
 * Pass `redirectPath` (e.g. '/alfred-ai-target-customer-guide') to preserve the page the user was
 * trying to reach before hitting the auth wall. `auth-action.html` reads continueUrl from Firebase's
 * URL params and does window.location.replace(continueUrl), so the redirect param survives intact.
 */
const BASE_PATH = '/auth?mode=login&reset=success';

function isLocalDevHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getPasswordResetContinueUrl(redirectPath?: string): string {
  const suffix =
    redirectPath ? `&redirect=${encodeURIComponent(redirectPath)}` : '';

  const explicit = process.env.REACT_APP_PASSWORD_RESET_CONTINUE_ORIGIN?.trim();
  if (explicit) {
    return `${explicit.replace(/\/+$/, '')}${BASE_PATH}${suffix}`;
  }

  const canonicalBase =
    process.env.REACT_APP_FIREBASE_HOSTING_CANONICAL_URL?.trim() || 'https://voluntas.web.app';

  if (typeof window === 'undefined') {
    return `${canonicalBase.replace(/\/+$/, '')}${BASE_PATH}${suffix}`;
  }

  const host = window.location.hostname.toLowerCase();
  if (isLocalDevHost(host)) {
    return `${window.location.origin}${BASE_PATH}${suffix}`;
  }

  return `${canonicalBase.replace(/\/+$/, '')}${BASE_PATH}${suffix}`;
}
